@if (!erweiterteSucheActive()) {
  <button
    type="button"
    class="now-btn now-btn-secondary now-btn-icon now-icon-plus-after"
    (click)="activateWeitereFilter()"
  >
    Weitere Filter
  </button>
}
